import { Navigate, Outlet } from "react-router-dom";
import { getAccessToken } from "context/OAuth/authService";

const AuthRoutes = () => {
  const isAuthenticated = !!getAccessToken();

  if (isAuthenticated) {
    return <Navigate to="/" replace />;
  }

  return <Outlet />;
};
export default AuthRoutes;